import { Box } from '@material-ui/core';

import { SBase, SText } from '@setvi/shared/components';

import { CustomizeDialogProps } from './types';
import { useStyles } from './styles';
import { useCustomizeDialog } from './hooks/use-customize-dialog';
import { PreviewPanel } from '../preview-panel';
import { CoverSection, OrderNotes, QrSection } from './components';

export const CustomizeDialog = ({
  resource,
  initial,
  confirmLabel = 'Add to Cart',
  isEdit = false,
  onClose
}: CustomizeDialogProps) => {
  const classes = useStyles();
  const { hint, qr, cover, notes, preview, footer } = useCustomizeDialog({
    resource,
    initial,
    isEdit,
    onClose
  });

  return (
    <SBase
      width={960}
      header={{ title: resource.Name, onClose }}
      footer={{
        onConfirm: footer.handleConfirm,
        onClose,
        confirmLabel,
        closeLabel: 'Cancel',
        disableConfirm: !footer.canContinue || footer.isSyncing,
        confirmLoading: footer.isSyncing,
        disableClose: footer.isSyncing,
        startIcon: <span className={classes.plusIcon}>+</span>,
        divider: true
      }}>
      <Box className={classes.content}>
        <Box className={classes.previewColumn}>
          <PreviewPanel
            document={preview.previewDocument}
            pages={preview.previewPages}
            hasPreview={preview.hasPreview}
            emptyMessage={preview.emptyMessage}
            generating={preview.generating}
            loading={preview.coverLoading}
            pageIndex={preview.pageIndex}
            onPageChange={preview.onPageChange}
          />
        </Box>

        <Box className={classes.customizeColumn}>
          <SText title="Customize" size="lg" weight="bold" />

          <Box className={classes.sections}>
            {qr.hasOption && <QrSection {...qr} />}

            {cover.hasOption && <CoverSection resource={resource} {...cover} />}

            {notes.visible && (
              <OrderNotes
                accepted={notes.accepted}
                onToggle={notes.setAccepted}
              />
            )}

            {hint && (
              <SText
                title={hint}
                size="sm"
                fontColor="#5D7083"
                maxLines="unset"
              />
            )}
          </Box>
        </Box>
      </Box>
    </SBase>
  );
};
